module.exports = __webpack_public_path__ + "img/neonatology3.e371d81b.jpg";